import React, { useState } from 'react'

const FEATURES = [
  { icon: 'BB', label: 'Bought-Bought', desc: 'この商品を買った人はこちらも購入', scene: '商品詳細 / カート' },
  { icon: 'OB', label: 'Viewed-Bought', desc: 'この商品を見た人はこちらを購入', scene: '商品詳細' },
  { icon: 'AI', label: 'Personal', desc: 'あなたへのおすすめ', scene: 'TOP / マイページ' },
  { icon: '~', label: 'Similar', desc: '類似商品レコメンド', scene: '商品詳細 / 検索結果' },
  { icon: '@', label: 'Mail', desc: 'メール配信用レコメンド', scene: 'メルマガ / CRM' },
]

const PAIN_POINTS = [
  { problem: '画一的な商品表示', impact: '全ユーザーに同じ人気ランキング。嗜好が反映されず離脱率が増加', color: '#ef4444' },
  { problem: 'データ活用の壁', impact: '閲覧・購買履歴は蓄積されているが、レコメンドに反映する仕組みがない', color: '#f59e0b' },
  { problem: '効果測定が曖昧', impact: 'どの枠がCVRに貢献しているか定量的に把握できない', color: '#8b5cf6' },
  { problem: '在庫切れの表示', impact: '在庫0の商品がレコメンドに出続け、UXを損なう', color: '#ec4899' },
  { problem: '導入コストが高い', impact: 'カスタム開発やSI案件になりがちで、初期費用・工期が肥大化する', color: '#3b82f6' },
  { problem: 'メールの手動選定', impact: 'メルマガのおすすめ商品を人手で選定。工数がかかり更新頻度が低い', color: '#10b981' },
]

const ADMIN_FEATURES = [
  { category: 'Valuable Data', color: '#f59e0b', items: [
    { title: '顧客カルテ', desc: '匿名訪問者から会員まで、一人ひとりの閲覧・カート・購入・レコメンド配信履歴を時系列で可視化。AIが行動パターンを分析しインサイトを自動生成' },
    { title: 'ジャーニー分析', desc: '購買ファネル（閲覧→商品詳細→カート→購入）の到達率と離脱率を自動集計。購入導線Top5・離脱ページTop10の特定とAI改善提案を提供' },
    { title: '配信内容決定（A/Bテスト）', desc: 'レコメンドロジック・デザインの異なるパターンを同時配信し、CTR・CVR・売上をリアルタイム比較。データドリブンで最適な配信設定を決定' },
  ]},
  { category: 'コンテンツ管理', color: '#6366f1', items: [
    { title: '商品マスタ管理', desc: 'CSV一括登録対応。商品名・画像・価格・外部IDを管理' },
    { title: 'カテゴリマスタ', desc: '階層カテゴリ管理。カテゴリ別レコメンドの精度を向上' },
    { title: 'カテゴリ紐づけ', desc: '商品×カテゴリの対応をCSV一括設定。マッピング率を可視化' },
    { title: '在庫管理', desc: '在庫数を管理し、在庫0以下の商品をレコメンドから自動除外' },
  ]},
  { category: 'レコメンド配信', color: '#8b5cf6', items: [
    { title: 'ウィジェット作成', desc: 'レコメンド表示枠を作成。ロジック・レイアウト・表示件数・CSSを設定' },
    { title: 'AI CSS生成', desc: 'ECサイトURLを入力するだけで、サイトのデザインに合ったCSSをAIが自動生成' },
    { title: 'ビジュアルCSSエディタ', desc: 'プレビュー付きのGUIでウィジェットデザインをリアルタイム編集' },
    { title: 'A/Bテスト', desc: 'ロジック・デザインの最大5パターンをトラフィック比率指定でテスト配信' },
  ]},
  { category: 'タグ・実装', color: '#3b82f6', items: [
    { title: '配信タグ自動生成', desc: '基本タグ・閲覧・カート・購入・表示用の6種タグをワンクリックでコピー' },
    { title: '設定ガイド', desc: '16ステップの導入チェックリスト。進捗率と完了状況をリアルタイム表示' },
    { title: 'メールAPI連携', desc: 'メール配信システムからAPIを呼び出し、パーソナライズ商品をメールに埋め込み' },
    { title: 'マルチサイト対応', desc: '1つの管理画面で複数ECサイトのレコメンドを一元管理' },
  ]},
  { category: 'コンテンツ解析・GEO', color: '#ec4899', items: [
    { title: 'AI解析タグ紐づけ', desc: '商品テキストからAIが11カテゴリのタグを自動抽出。レコメンドスコアの補正、顧客の興味関心推定、記事キーワード候補に活用' },
    { title: '特集記事作成', desc: 'Googleサジェスト自動展開、ワードマップ可視化、CVE・難易度・ジャンル分析でPascal SEO同等のキーワード選定。AI記事構成案・CSV出力にも対応' },
    { title: '特集リライト判定', desc: '既存特集ページのSEO診断（5項目100点）を実施し、AIがタイトル・メタ・見出しのリライト案を自動生成。一括診断で優先度を可視化' },
    { title: 'GEO/LLMO分析', desc: 'ChatGPT等のAI検索で自社ブランドがどう語られるかを4つの分析で可視化。サイテーション・SOV・センチメント・クエリ持続性を測定' },
  ]},
]

const ANALYSIS_FEATURES = [
  { icon: 'ID', title: '顧客カルテ', color: '#6366f1', items: [
    '訪問者ごとの行動タイムラインを時系列で可視化',
    '匿名Cookie IDと会員IDの自動紐づけ',
    '閲覧・カート・購入・レコメンド配信・クリックを統合表示',
    'AIが顧客の行動パターンを自動分析し、インサイトを生成',
    'デバイス・ブラウザ別のアクセス分布を可視化',
  ]},
  { icon: '>>', title: 'ジャーニー分析', color: '#10b981', items: [
    '30分ギャップでセッション分割し、購買ファネルを自動構築',
    'view → view_product → cart → order の各ステップ到達率と離脱率を表示',
    '購入に至った導線パターンTop5を自動集計',
    '離脱率の高いページTop10を特定',
    'AIが分析データを元に具体的な改善提案を自動生成',
  ]},
  { icon: 'AB', title: 'A/Bテスト分析', color: '#f59e0b', items: [
    'ウィジェット別の表示回数・クリック数・CVR・売上を自動集計',
    'A/Bパターン別の効果比較レポート',
    'CTR・CVR・売上の日別推移グラフ',
    'データドリブンで最適な配信パターンを選定',
  ]},
  { icon: '{}', title: '配信実績レポート', color: '#ec4899', items: [
    'ウィジェット別のインプレッション・クリック・コンバージョン・売上',
    'ROAS（広告費用対効果）に相当するレコメンド経由売上を可視化',
    '日別推移グラフで配信効果のトレンドを確認',
    '期間フィルター（7日/14日/30日/90日）でレポート生成',
  ]},
  { icon: '🏷', title: 'AIタグ × レコメンド連動', color: '#ec4899', items: [
    'AIが商品から抽出した11カテゴリのタグでレコメンドスコアを最大30%ブースト',
    '顧客が閲覧した商品のAIタグから興味関心を自動推定し、カルテに表示',
    'キーワード選定のAI分析にAIタグ情報を自動注入し、商品に即したKW提案',
    'タグ効果トラッキングでCTR・CVRへの貢献度を可視化',
  ]},
]

const TRACKING_EVENTS = [
  { event: 'ページ閲覧', classify: 'view', desc: '全ページの訪問を自動記録。有料オプションだが、カスタマージャーニー分析を行え、離脱経路、CVの王道経路を特定し改善アドバイスをもらえる。', tag: '基本タグ' },
  { event: '商品詳細閲覧', classify: 'view_product', desc: '商品ID・カテゴリIDを送信', tag: '閲覧タグ' },
  { event: 'カテゴリ閲覧', classify: 'view_category', desc: '商品検索やカテゴリ検索など様々な商品一覧の表示を記録します。', tag: '閲覧タグ' },
  { event: 'カート追加', classify: 'cart', desc: 'カートに追加された商品を記録することで、その後の購入完了やカゴ落ちの分析を可能にします。', tag: 'カートタグ' },
  { event: '購入完了', classify: 'order', desc: '注文が完了することで重要なコンバージョンを記録します。複数カートにも対応しています。', tag: '購入タグ' },
  { event: 'レコメンド表示', classify: 'impression', desc: '様々なウィジェットを配置し、その表示回数を測定しています。', tag: '表示タグ' },
  { event: 'レコメンドクリック', classify: 'click', desc: 'ウィジェットにより表示された商品がクリックされることを記録しています。最終的には購入まで追いかけています。', tag: '表示タグ' },
]

const STEPS = [
  { num: '01', title: '初期設定', duration: '即日', desc: '管理画面でサイト登録 → 商品マスタCSV登録 → カテゴリ設定', color: '#6366f1' },
  { num: '02', title: 'ウィジェット作成', duration: '即日', desc: 'レコメンド表示枠を作成。AI CSSでデザインを自動調整', color: '#8b5cf6' },
  { num: '03', title: 'タグ設置', duration: '1〜3日', desc: 'ECサイトに配信タグ（6種）を設置。コピペで完了', color: '#a78bfa' },
  { num: '04', title: 'データ蓄積', duration: '1〜2週', desc: '行動データの自動蓄積。設定ガイドで取得状況を確認', color: '#7c3aed' },
  { num: '05', title: '分析・最適化', duration: '継続的', desc: 'ジャーニー分析・A/Bテストでレコメンド精度を継続改善', color: '#6d28d9' },
]

const KPIS = [
  { label: 'CVR向上', value: 'UP', desc: 'パーソナライズで購入転換率を改善', icon: '/' },
  { label: '客単価UP', value: '+', desc: 'BB/OBによるクロスセル促進', icon: '$' },
  { label: '回遊率UP', value: '>>', desc: 'Personal・Similarで滞在時間向上', icon: '~' },
  { label: '運用工数削減', value: 'AUTO', desc: 'AI自動選定で手動設定が不要に', icon: '*' },
]

const EC_FEATURES_PAGE = [
  {
    icon: 'TOP',
    title: 'TOPページ パーソナライズレコメンド',
    scene: 'TOPページ / マイページ',
    logic: 'Personal',
    desc: '訪問者の過去の閲覧・購買履歴をAIが即座に分析し、一人ひとりに最適な商品を自動表示。初回訪問でも人気商品を提示し、再訪問のたびに精度が向上する、まさに「育つレコメンド」です。',
  },
  {
    icon: 'BB',
    title: '「この商品を買った人はこちらも購入」',
    scene: '商品詳細ページ / カートページ',
    logic: 'Bought-Bought',
    desc: '数万件の購買履歴を協調フィルタリングで解析し、同時購入パターンを自動抽出。「一緒に買われている商品」を的確に表示することで、客単価アップとまとめ買いを自然に促進します。',
  },
  {
    icon: 'OB',
    title: '「この商品を見た人はこちらを購入」',
    scene: '商品詳細ページ',
    logic: 'Viewed-Bought',
    desc: '閲覧行動と購買行動のクロス分析により、「見ている人が最終的に買う商品」を予測表示。比較検討中のユーザーの背中を押し、迷いを解消して購入決定までの最短導線を実現します。',
  },
  {
    icon: '~',
    title: '類似商品レコメンド',
    scene: '商品詳細ページ / 検索結果ページ',
    logic: 'Similar',
    desc: '商品の属性・カテゴリ・価格帯をコンテンツベースAIが多角的に分析し、本当に似ている商品を厳選表示。在庫切れ商品の代替提案やサイズ違い・色違いの発見にも活用できます。',
  },
  {
    icon: '$',
    title: 'カートページ クロスセル',
    scene: 'カートページ',
    logic: 'BB / OB',
    desc: '購入直前のカートページで、カート内商品と相性の良いアイテムを提案。「あと1点で送料無料」と組み合わせれば、客単価と顧客満足度を同時に引き上げる最後のひと押しになります。',
  },
  {
    icon: '#',
    title: 'カテゴリページ おすすめ',
    scene: 'カテゴリ一覧ページ',
    logic: 'Personal / BB',
    desc: 'カテゴリ内で訪問者の嗜好に合った商品を優先表示。大量の商品に埋もれがちな隠れた名品を発掘し、カテゴリ回遊率と商品発見率を大幅に向上させます。',
  },
]

const EC_FEATURES_MAIL = [
  {
    icon: '@',
    title: 'メール パーソナライズレコメンド',
    scene: 'メルマガ / CRM / ステップメール',
    logic: 'Mail API',
    desc: 'メール配信システムからAPIを1回呼ぶだけで、受信者ごとに最適な商品リストを自動取得。手動の商品選定作業をゼロにし、開封後のクリック率と購入率を飛躍的に高めます。',
  },
  {
    icon: 'RE',
    title: 'リターゲティングメール連携',
    scene: 'カゴ落ちメール / 閲覧リマインド',
    logic: 'Personal / BB',
    desc: 'カート放棄ユーザーや閲覧離脱ユーザーに対して、その人が興味を持った商品＋関連商品をセットで配信。単純なリマインドではなく、新たな購買動機を生み出すメール体験を提供します。',
  },
]

const SCALABILITY_FEATURES = [
  { category: 'サーバー基盤', color: '#6366f1', items: [
    { title: 'マルチワーカー構成', desc: 'Gunicorn + UvicornWorker による並列処理。複数リクエストを同時に捌き、単一プロセスのボトルネックを解消' },
    { title: 'DB接続プール', desc: 'PostgreSQL接続を事前確保（pool_size=10, max_overflow=5）。接続の生成・破棄コストをゼロにし、応答時間を安定化' },
    { title: 'パフォーマンスインデックス', desc: '主要テーブル10箇所にDBインデックスを最適配置。商品ID解決・ウィジェット取得・コンバージョン追跡のクエリを2-3倍高速化' },
  ]},
  { category: 'キャッシュ戦略', color: '#10b981', items: [
    { title: 'サーバー側インメモリキャッシュ', desc: 'サイト設定(5分)・ウィジェット(5分)・商品ID(10分)・在庫フィルタ(1分)をプロセス内キャッシュ。DBクエリを30-40%削減' },
    { title: 'クライアント側キャッシュ', desc: 'サイト設定をlocalStorage(5分)、レコメンド結果をsessionStorage(5分)にキャッシュ。サーバーへのリクエスト数を30-50%削減' },
    { title: 'キャッシュ即時無効化', desc: '管理画面でウィジェットや設定を変更すると、サーバーキャッシュを即時パージ。古いデータが配信されるリスクを排除' },
  ]},
  { category: 'ECサイト耐障害性', color: '#f59e0b', items: [
    { title: 'フェッチタイムアウト (5秒)', desc: 'AbortControllerで全APIリクエストに5秒タイムアウトを設定。サーバー無応答時もECサイトの表示をブロックしない' },
    { title: 'サーキットブレーカー', desc: '3回連続失敗で30秒間リクエストを自動停止。障害時の無駄なリクエストを抑制し、復旧後に自動再開' },
    { title: '動的スクリプトロード', desc: 'JSファイルを非同期動的読み込み。サービスダウン時もECサイトのページ表示が一切影響を受けない' },
  ]},
  { category: 'トラフィック制御', color: '#ec4899', items: [
    { title: 'レコメンド配信率コントロール', desc: '管理画面から0-100%でレコメンド配信率を即時変更。ピーク時に30%に下げれば、レコメンドAPIへのリクエストを70%削減' },
    { title: 'visitor_id 決定的サンプリング', desc: '同一ユーザーはページ遷移しても常に同じ判定結果。チラつきなく一貫した体験を維持しつつ、負荷を正確にコントロール' },
    { title: 'バッチクエリ最適化', desc: 'カート・購入時の商品ID解決・在庫更新・コンバージョン照合をIN句で一括処理。N+1問題を排除しTrackエンドポイントを2-3倍高速化' },
  ]},
]

const SCALABILITY_SPECS = [
  { label: '想定処理能力', value: '~28 RPS', desc: '1時間10万PV相当' },
  { label: 'レコメンド応答', value: '<200ms', desc: 'キャッシュヒット時' },
  { label: 'DB接続プール', value: '15本', desc: 'pool_size=10 + overflow=5' },
  { label: 'JS読込影響', value: '0ms', desc: 'サービスダウン時もブロックなし' },
]

const EC_FEATURES_DESIGN = [
  {
    icon: '[ ]',
    title: 'グリッドレイアウト',
    desc: '商品を均等なカード型で並べる定番レイアウト。カテゴリページや検索結果との統一感を保ちつつ、商品画像を最大限に活かして視覚的な訴求力を高めます。',
  },
  {
    icon: '< >',
    title: 'カルーセルレイアウト',
    desc: '左右スワイプで多数の商品をコンパクトに表示。限られたスペースでも10商品以上を配置でき、モバイルでの操作性とPC上でのリッチ感を両立するレイアウトです。',
  },
  {
    icon: '>>',
    title: 'スライダーレイアウト',
    desc: '自動スクロールで商品が流れるように表示される動的レイアウト。ユーザーの視線を自然に引きつけ、ファーストビュー外の商品も確実に目に触れる機会を創出します。',
  },
  {
    icon: '=',
    title: 'リストレイアウト',
    desc: '商品名・価格・説明文を一覧形式で表示。比較検討しやすいフォーマットで、スペック重視のユーザーに最適。サイドバーや狭いスペースへの設置にも対応できます。',
  },
  {
    icon: 'AI',
    title: 'AI CSS自動生成',
    desc: 'ECサイトのURLを入力するだけで、AIがサイトのデザインテイスト・配色・フォントを解析し、違和感なく溶け込むCSSを自動生成。デザイナー不要で即座にプロ品質を実現します。',
  },
  {
    icon: 'Aa',
    title: 'レコメンドタイトル表示',
    desc: '「この商品を買った人はこちらも購入」「あなたへのおすすめ」など、ウィジェットごとに自由なタイトルテキストを設定。ロジックに合わせた訴求文でクリック率をさらに向上させます。',
  },
  {
    icon: '0>',
    title: '在庫連動フィルタ',
    desc: '在庫数をリアルタイムで参照し、在庫ゼロの商品をレコメンド結果から自動除外。「クリックしたら売り切れ」というUX低下を完全に防ぎ、離脱率削減と信頼性向上を同時に達成します。',
  },
  {
    icon: 'AB',
    title: 'A/Bテスト最適化',
    desc: 'ロジック・デザインの異なるパターンを最大5種同時配信し、CTR・CVR・売上をリアルタイム比較。勘や経験ではなくデータに基づく意思決定で、レコメンド効果を最大化します。',
  },
]

const SLIDES = [
  { label: '課題認識', msg: 'なぜ今、パーソナライズが必要なのか' },
  { label: 'エンジン概要', msg: '3層AIが実現する5つのロジック' },
  { label: '管理画面の機能', msg: '専門知識不要、すべてをノーコードで' },
  { label: 'データ分析・AI', msg: 'AIが売上改善アクションを自動提案' },
  { label: '導入効果', msg: 'CVR・客単価・回遊率を同時に改善' },
  { label: '導入ステップ', msg: '最短即日、タグを貼るだけで稼働' },
  { label: 'サイト表示機能', msg: 'ページごとに最適な商品を自動配信' },
  { label: 'メール・配信', msg: 'メールもAIで一人ひとりに最適化' },
  { label: 'デザイン・最適化', msg: 'A/BテストでROIを最大化' },
  { label: '高負荷対策', msg: 'ECサイトに影響を与えない堅牢設計' },
  { label: 'W2Commerce完全連動', msg: 'ECプラットフォーム深度統合' },
  { label: 'GEO/LLMO分析', msg: 'AI検索時代のブランド可視化戦略' },
]

export default function ProposalOverview() {
  const [activeSlide, setActiveSlide] = useState(0)

  return (
    <div style={s.page}>
      {/* Hero */}
      <section style={s.hero}>
        <div style={s.heroBadge}>SERVICE GUIDE</div>
        <h1 style={s.heroTitle}>
          <span style={s.heroAccent}>Reco-Media</span>
          <span style={{ display: 'block', fontSize: '0.4em', fontWeight: 400, marginTop: 8, opacity: 0.8 }}>powered by W2 Smart Hub</span>
        </h1>
        <p style={s.heroSub}>AI Hybrid Recommendation Engine for EC</p>
        <p style={s.heroDesc}>
          3層ハイブリッドAIが、一人ひとりに最適な商品を自動レコメンド。<br />
          JSタグ1行で導入完了。データが貯まるほど賢くなるレコメンドエンジン。
        </p>
        <div style={s.engineLabelWrap}>
          <div style={s.engineLabelLine} />
          <span style={s.engineLabel}>3-Layer Hybrid AI Engine</span>
          <div style={s.engineLabelLine} />
        </div>
        <div style={s.heroEngine}>
          {[
            { w: '40', n: '協調フィルタリング', d: '購買行動の類似性から推薦' },
            { w: '40', n: 'ニューラルエンジン', d: '深層学習による嗜好予測' },
            { w: '20', n: 'コンテンツベース', d: '商品属性の類似度分析' },
          ].map((e, i) => (
            <React.Fragment key={i}>
              {i > 0 && <div style={s.engineX}><span style={s.engineXmark}>×</span></div>}
              <div style={s.engineBlock}>
                <div style={s.engineWeight}>{e.w}<span style={s.enginePct}>%</span></div>
                <div style={s.engineName}>{e.n}</div>
                <div style={s.engineDetail}>{e.d}</div>
              </div>
            </React.Fragment>
          ))}
        </div>
        <div style={s.engineResult}>= 最適なレコメンド結果</div>

      </section>

      {/* Agenda Grid */}
      <section style={s.agendaSection}>
        <h2 style={s.agendaSectionTitle}>W2 Smart Hub の特徴紹介</h2>
        <p style={s.agendaHint}>クリックすると各特徴を個別に紹介します</p>
        <div style={s.agendaGrid}>
          {SLIDES.map((sl, i) => {
            const isActive = activeSlide === i
            return (
              <button
                key={i}
                onClick={() => setActiveSlide(i)}
                style={{
                  ...s.agendaCard,
                  ...(isActive ? s.agendaCardActive : {}),
                }}
              >
                <div style={{ ...s.agendaNum, ...(isActive ? s.agendaNumActive : {}) }}>
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div style={s.agendaBody}>
                  <div style={{ ...s.agendaLabel, ...(isActive ? s.agendaLabelActive : {}) }}>{sl.label}</div>
                  <div style={{ ...s.agendaMsg, ...(isActive ? s.agendaMsgActive : {}) }}>{sl.msg}</div>
                </div>
              </button>
            )
          })}
        </div>
      </section>

      <div style={s.sectionDivider} />

      {/* Slide 1: 課題認識 */}
      {activeSlide === 0 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>01</span>
            <div>
              <h2 style={s.sectionTitle}>EC事業者が直面する課題</h2>
              <p style={s.sectionSub}>なぜ、御社のECサイトはリピーターが定着しないのか</p>
            </div>
          </div>

          <div style={s.painGrid}>
            {PAIN_POINTS.map((p, i) => (
              <div key={i} style={s.painCard}>
                <div style={{ ...s.painDot, background: p.color }} />
                <div>
                  <h3 style={s.painTitle}>{p.problem}</h3>
                  <p style={s.painDesc}>{p.impact}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={s.statBanner}>
            <div style={s.statIcon}>!</div>
            <p style={s.statText}>
              EC事業者の約<span style={s.statHighlight}>70%</span>が
              「パーソナライゼーションの重要性は理解しているが、実装できていない」と回答
            </p>
          </div>

          <div style={{ ...s.solutionBanner, marginTop: 20 }}>
            <div style={s.solutionIcon}>W2</div>
            <div>
              <h4 style={s.solutionTitle}>W2 Smart Hub がすべて解決</h4>
              <p style={s.solutionDesc}>
                JSタグ1行の設置で導入完了。5つのレコメンドロジック、在庫連動、A/Bテスト、
                顧客カルテ、ジャーニー分析、AI改善提案まで、ワンストップで提供します。
              </p>
            </div>
          </div>
        </section>
      )}

      {/* Slide 2: エンジン概要 */}
      {activeSlide === 1 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>02</span>
            <div>
              <h2 style={s.sectionTitle}>5つのレコメンドロジック</h2>
              <p style={s.sectionSub}>ページ種別やシーンに応じて、最適なロジックを自動選定</p>
            </div>
          </div>

          <div style={s.logicGrid5}>
            {FEATURES.map((f, i) => (
              <div key={i} style={s.logicCard}>
                <div style={s.logicIcon}>{f.icon}</div>
                <div style={s.logicLabel}>{f.label}</div>
                <p style={s.logicDesc}>{f.desc}</p>
                <span style={s.logicScene}>{f.scene}</span>
              </div>
            ))}
          </div>

          {/* Tracking events */}
          <h3 style={{ ...s.subHeading, marginTop: 36 }}>自動トラッキングイベント</h3>
          <p style={s.subDesc}>6種の配信タグで、ECサイトの全行動を自動で記録。レコメンド精度の基盤となるデータを蓄積します。</p>
          <div style={s.trackingTable}>
            <div style={s.trackingHeader}>
              <span style={{ flex: 2 }}>イベント</span>
              <span style={{ flex: 1 }}>分類タグ</span>
              <span style={{ flex: 4 }}>内容</span>
              <span style={{ flex: 1 }}>タグ種別</span>
            </div>
            {TRACKING_EVENTS.map((t, i) => (
              <div key={i} style={s.trackingRow}>
                <span style={{ flex: 2, fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>{t.event}</span>
                <span style={{ flex: 1 }}>
                  <span style={s.classifyBadge}>{t.classify}</span>
                </span>
                <span style={{ flex: 4, color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>{t.desc}</span>
                <span style={{ flex: 1 }}>
                  <span style={s.tagBadge}>{t.tag}</span>
                </span>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Slide 3: 管理画面の機能 */}
      {activeSlide === 2 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>03</span>
            <div>
              <h2 style={s.sectionTitle}>管理画面の機能一覧</h2>
              <p style={s.sectionSub}>専門知識不要。直感的なUIで全機能を操作できます</p>
            </div>
          </div>

          {ADMIN_FEATURES.map((cat, ci) => (
            <div key={ci} style={{ marginBottom: 28 }}>
              <div style={s.adminCatHeader}>
                <span style={{ ...s.adminCatDot, background: cat.color }} />
                <h3 style={s.adminCatTitle}>{cat.category}</h3>
              </div>
              <div style={s.adminGrid}>
                {cat.items.map((item, ii) => (
                  <div key={ii} style={s.adminCard}>
                    <div style={{ ...s.adminCardBar, background: cat.color }} />
                    <h4 style={s.adminCardTitle}>{item.title}</h4>
                    <p style={s.adminCardDesc}>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Additional highlights */}
          <div style={s.highlightBanner}>
            <div style={s.highlightItem}>
              <span style={s.highlightIcon}>++</span>
              <div>
                <div style={s.highlightTitle}>マルチサイト対応</div>
                <div style={s.highlightDesc}>1管理画面で複数ECサイトを一元管理</div>
              </div>
            </div>
            <div style={s.highlightDivider} />
            <div style={s.highlightItem}>
              <span style={s.highlightIcon}>*</span>
              <div>
                <div style={s.highlightTitle}>オペレーター権限管理</div>
                <div style={s.highlightDesc}>管理者/サイト別のアクセス制御</div>
              </div>
            </div>
            <div style={s.highlightDivider} />
            <div style={s.highlightItem}>
              <span style={s.highlightIcon}>0&gt;</span>
              <div>
                <div style={s.highlightTitle}>受注履歴インポート</div>
                <div style={s.highlightDesc}>CSV一括取込でレコメンド精度を即向上</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Slide 4: データ分析・AI */}
      {activeSlide === 3 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>04</span>
            <div>
              <h2 style={s.sectionTitle}>データ分析・AI活用機能</h2>
              <p style={s.sectionSub}>蓄積データをAIが自動分析し、売上改善の具体的アクションを提案</p>
            </div>
          </div>

          {ANALYSIS_FEATURES.map((af, i) => (
            <div key={i} style={s.analysisCard}>
              <div style={s.analysisHeader}>
                <div style={{ ...s.analysisIcon, background: `${af.color}18`, color: af.color }}>{af.icon}</div>
                <h3 style={s.analysisTitle}>{af.title}</h3>
              </div>
              <div style={s.analysisList}>
                {af.items.map((item, j) => (
                  <div key={j} style={s.analysisItem}>
                    <span style={{ ...s.analysisDot, background: af.color }} />
                    <span style={s.analysisText}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div style={s.aiBanner}>
            <div style={s.aiIcon}>AI</div>
            <div>
              <h4 style={s.aiBannerTitle}>Claude AI による自動分析</h4>
              <p style={s.aiBannerDesc}>
                顧客カルテのインサイト生成、ジャーニー分析の改善提案、ウィジェットCSS自動生成など、
                Claude AI が管理画面内で直接サポートします。専門知識がなくても、
                AIの提案に沿って改善アクションを実行できます。
              </p>
            </div>
          </div>
        </section>
      )}

      {/* Slide 5: 導入効果 */}
      {activeSlide === 4 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>05</span>
            <div>
              <h2 style={s.sectionTitle}>導入効果</h2>
              <p style={s.sectionSub}>データが貯まるほど賢くなるレコメンドで、4つのKPIを改善</p>
            </div>
          </div>

          <div style={s.kpiGrid}>
            {KPIS.map((k, i) => (
              <div key={i} style={s.kpiCard}>
                <div style={s.kpiIcon}>{k.icon}</div>
                <div style={s.kpiValue}>{k.value}</div>
                <div style={s.kpiLabel}>{k.label}</div>
                <p style={s.kpiDesc}>{k.desc}</p>
              </div>
            ))}
          </div>

          <div style={s.dashPreview}>
            <h4 style={s.dashTitle}>管理画面で効果をリアルタイム可視化</h4>
            <div style={s.dashGrid}>
              <div style={s.dashItem}><span style={s.dashDot1} />ウィジェット別 表示回数 / クリック / CV / 売上</div>
              <div style={s.dashItem}><span style={s.dashDot2} />CTR・CVR の自動算出</div>
              <div style={s.dashItem}><span style={s.dashDot3} />A/Bパターン別比較レポート</div>
              <div style={s.dashItem}><span style={s.dashDot4} />日別推移グラフ</div>
              <div style={s.dashItem}><span style={s.dashDot1} />購買ファネル（4ステップ到達率）</div>
              <div style={s.dashItem}><span style={s.dashDot2} />購入導線Top5 / 離脱ページTop10</div>
              <div style={s.dashItem}><span style={s.dashDot3} />顧客別行動タイムライン</div>
              <div style={s.dashItem}><span style={s.dashDot4} />AIによる改善提案レポート</div>
            </div>
          </div>

          {/* Before / After comparison */}
          <h3 style={{ ...s.subHeading, marginTop: 36 }}>導入 Before / After</h3>
          <div style={s.compareGrid}>
            <div style={s.compareCard}>
              <div style={s.compareBadgeBefore}>BEFORE</div>
              <div style={s.compareList}>
                <div style={s.compareItem}>全員に同じ人気ランキングを表示</div>
                <div style={s.compareItem}>メルマガの商品を手動で選定</div>
                <div style={s.compareItem}>在庫切れ商品がレコメンドに表示</div>
                <div style={s.compareItem}>効果測定の仕組みがない</div>
                <div style={s.compareItem}>顧客の行動が見えない</div>
              </div>
            </div>
            <div style={s.compareArrow}>&#10132;</div>
            <div style={s.compareCard}>
              <div style={s.compareBadgeAfter}>AFTER</div>
              <div style={s.compareList}>
                <div style={s.compareItemGood}>一人ひとりにパーソナライズされた商品を表示</div>
                <div style={s.compareItemGood}>メールもAPI連携で自動パーソナライズ</div>
                <div style={s.compareItemGood}>在庫連動フィルタで自動除外</div>
                <div style={s.compareItemGood}>ウィジェット別CTR/CVR/売上を自動集計</div>
                <div style={s.compareItemGood}>顧客カルテ + AIインサイトで行動を可視化</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Slide 6: 導入ステップ */}
      {activeSlide === 5 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>06</span>
            <div>
              <h2 style={s.sectionTitle}>導入ステップ</h2>
              <p style={s.sectionSub}>最短即日で導入開始。段階的にデータを蓄積し、分析・最適化を進めます</p>
            </div>
          </div>

          <div style={s.stepsTimeline}>
            {STEPS.map((st, i) => (
              <div key={i} style={s.timelineItem}>
                <div style={s.timelineLine}>
                  <div style={{ ...s.timelineDot, background: st.color }} />
                  {i < STEPS.length - 1 && <div style={s.timelineConnector} />}
                </div>
                <div style={s.timelineContent}>
                  <div style={s.timelineHeader}>
                    <span style={{ ...s.timelineNum, background: st.color }}>STEP {st.num}</span>
                    <span style={s.timelineDuration}>{st.duration}</span>
                  </div>
                  <h4 style={s.timelineTitle}>{st.title}</h4>
                  <p style={s.timelineDesc}>{st.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Setup guide mention */}
          <div style={s.guidePreview}>
            <h4 style={s.guideTitle}>設定ガイドで迷わず進行</h4>
            <p style={s.guideDesc}>
              管理画面の「設定ガイド」機能が、16のチェック項目で進捗を可視化。
              コンテンツ準備 → タグ設置 → ウィジェット作成 → データ取得確認 → 分析活用まで、
              ステップバイステップでナビゲートします。
            </p>
            <div style={s.guideSteps}>
              {['STEP1 コンテンツ準備', 'STEP2 配信タグ設置', 'STEP3 ウィジェット作成', 'STEP4 データ取得確認', 'STEP5 分析・活用'].map((label, i) => (
                <div key={i} style={s.guideStep}>
                  <span style={s.guideStepDot} />
                  {label}
                </div>
              ))}
            </div>
          </div>

          {/* Support */}
          <div style={s.supportBanner}>
            <h4 style={s.supportTitle}>導入サポート体制</h4>
            <div style={s.supportGrid}>
              <div style={s.supportItem}>
                <span style={s.supportIcon}>?</span>
                <div>
                  <div style={s.supportLabel}>技術サポート</div>
                  <div style={s.supportDesc}>タグ設置・API連携の技術支援</div>
                </div>
              </div>
              <div style={s.supportItem}>
                <span style={s.supportIcon}>!</span>
                <div>
                  <div style={s.supportLabel}>運用コンサルティング</div>
                  <div style={s.supportDesc}>A/Bテスト設計・レポート分析支援</div>
                </div>
              </div>
              <div style={s.supportItem}>
                <span style={s.supportIcon}>@</span>
                <div>
                  <div style={s.supportLabel}>カスタマイズ対応</div>
                  <div style={s.supportDesc}>独自ロジック・デザイン要件の対応</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Slide 7: サイト表示機能 */}
      {activeSlide === 6 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>07</span>
            <div>
              <h2 style={s.sectionTitle}>ECサイト レコメンド表示機能</h2>
              <p style={s.sectionSub}>ページ種別ごとに最適なレコメンドを自動配信。設置はタグを貼るだけ</p>
            </div>
          </div>

          <div style={s.ecFeatureList}>
            {EC_FEATURES_PAGE.map((f, i) => (
              <div key={i} style={s.ecFeatureCard}>
                <div style={s.ecFeatureLeft}>
                  <div style={s.ecFeatureIcon}>{f.icon}</div>
                  <div style={s.ecFeatureMeta}>
                    <span style={s.ecFeatureLogic}>{f.logic}</span>
                    <span style={s.ecFeatureScene}>{f.scene}</span>
                  </div>
                </div>
                <div style={s.ecFeatureRight}>
                  <h3 style={s.ecFeatureTitle}>{f.title}</h3>
                  <p style={s.ecFeatureDesc}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Slide 8: メール・配信 */}
      {activeSlide === 7 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>08</span>
            <div>
              <h2 style={s.sectionTitle}>メール・外部配信レコメンド機能</h2>
              <p style={s.sectionSub}>サイト外でもパーソナライズ。メールやCRMにAIレコメンドを組み込み</p>
            </div>
          </div>

          <div style={s.ecFeatureList}>
            {EC_FEATURES_MAIL.map((f, i) => (
              <div key={i} style={s.ecFeatureCard}>
                <div style={s.ecFeatureLeft}>
                  <div style={s.ecFeatureIcon}>{f.icon}</div>
                  <div style={s.ecFeatureMeta}>
                    <span style={s.ecFeatureLogic}>{f.logic}</span>
                    <span style={s.ecFeatureScene}>{f.scene}</span>
                  </div>
                </div>
                <div style={s.ecFeatureRight}>
                  <h3 style={s.ecFeatureTitle}>{f.title}</h3>
                  <p style={s.ecFeatureDesc}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Mail API flow */}
          <div style={s.mailFlowBox}>
            <h4 style={s.mailFlowTitle}>メールAPI連携フロー</h4>
            <div style={s.mailFlowSteps}>
              {[
                { num: '1', label: 'メール配信システム', desc: '顧客IDを指定してAPIを呼び出し' },
                { num: '2', label: 'W2 Smart Hub', desc: 'AIがリアルタイムで最適商品を選定' },
                { num: '3', label: 'JSONレスポンス', desc: '商品名・画像・価格・URLを返却' },
                { num: '4', label: 'メール本文に埋め込み', desc: 'テンプレートに商品情報を差し込み配信' },
              ].map((step, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <div style={s.mailFlowArrow}>&#10132;</div>}
                  <div style={s.mailFlowStep}>
                    <div style={s.mailFlowNum}>{step.num}</div>
                    <div style={s.mailFlowLabel}>{step.label}</div>
                    <div style={s.mailFlowDesc}>{step.desc}</div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Slide 9: デザイン・最適化 */}
      {activeSlide === 8 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>09</span>
            <div>
              <h2 style={s.sectionTitle}>表示デザイン・最適化機能</h2>
              <p style={s.sectionSub}>ノーコードで自在にデザイン。A/Bテストでデータドリブンに最適化</p>
            </div>
          </div>

          <div style={s.designGrid}>
            {EC_FEATURES_DESIGN.map((f, i) => (
              <div key={i} style={s.designCard}>
                <div style={s.designCardIcon}>{f.icon}</div>
                <div>
                  <h4 style={s.designCardTitle}>{f.title}</h4>
                  <p style={s.designCardDesc}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Slide 10: 高負荷対策・耐障害性 */}
      {activeSlide === 9 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>10</span>
            <div>
              <h2 style={s.sectionTitle}>高負荷対策・耐障害性</h2>
              <p style={s.sectionSub}>ECサイトの表示を一切ブロックしない堅牢なアーキテクチャ</p>
            </div>
          </div>

          {/* Spec badges */}
          <div style={s.specGrid}>
            {SCALABILITY_SPECS.map((sp, i) => (
              <div key={i} style={s.specCard}>
                <div style={s.specValue}>{sp.value}</div>
                <div style={s.specLabel}>{sp.label}</div>
                <div style={s.specDesc}>{sp.desc}</div>
              </div>
            ))}
          </div>

          {/* Feature categories */}
          {SCALABILITY_FEATURES.map((cat, ci) => (
            <div key={ci} style={{ marginBottom: 28 }}>
              <div style={s.adminCatHeader}>
                <span style={{ ...s.adminCatDot, background: cat.color }} />
                <h3 style={s.adminCatTitle}>{cat.category}</h3>
              </div>
              <div style={s.adminGrid}>
                {cat.items.map((item, ii) => (
                  <div key={ii} style={s.adminCard}>
                    <div style={{ ...s.adminCardBar, background: cat.color }} />
                    <h4 style={s.adminCardTitle}>{item.title}</h4>
                    <p style={s.adminCardDesc}>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Architecture diagram */}
          <div style={s.archBanner}>
            <h4 style={s.archTitle}>障害時のフォールバック設計</h4>
            <div style={s.archFlow}>
              {[
                { label: 'キャッシュ確認', desc: 'sessionStorageに結果があれば即表示', color: '#10b981' },
                { label: 'サンプリング判定', desc: '配信率に基づき対象外ならスキップ', color: '#f59e0b' },
                { label: 'サーキットブレーカー', desc: '連続失敗中ならリクエストせず非表示', color: '#ef4444' },
                { label: 'タイムアウト (5秒)', desc: '応答なしなら中断→ウィジェット非表示', color: '#8b5cf6' },
              ].map((step, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <div style={s.archArrow}>&#8595;</div>}
                  <div style={s.archStep}>
                    <div style={{ ...s.archDot, background: step.color }} />
                    <div>
                      <div style={s.archStepLabel}>{step.label}</div>
                      <div style={s.archStepDesc}>{step.desc}</div>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
            <div style={s.archResult}>
              ECサイトのページ表示・操作には一切影響なし
            </div>
          </div>
        </section>
      )}

      {/* Slide 11: W2Commerce完全連動 */}
      {activeSlide === 10 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>11</span>
            <div>
              <h2 style={s.sectionTitle}>W2Commerce 完全連動モード</h2>
              <p style={s.sectionSub}>W2 ECプラットフォームとの深度統合による次世代レコメンド</p>
            </div>
          </div>

          {/* モード比較テーブル */}
          <h3 style={{ ...s.subHeading, marginBottom: 14 }}>基本モード vs W2Commerce完全連動</h3>
          <div style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 14,
            overflow: 'hidden',
            marginBottom: 28,
          }}>
            {/* テーブルヘッダー */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '2fr 2fr 3fr',
              gap: 0,
              background: 'rgba(99,102,241,0.12)',
              padding: '10px 18px',
              fontSize: 11,
              fontWeight: 700,
              color: 'rgba(255,255,255,0.6)',
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              borderBottom: '1px solid rgba(255,255,255,0.08)',
            }}>
              <span>項目</span>
              <span>基本モード</span>
              <span>W2Commerce完全連動</span>
            </div>
            {[
              { item: 'データソース', basic: '商品マスタ・受注履歴・行動ログ', w2: '+ W2全14マスタ（ユーザー・商品・ブランド・カテゴリ・在庫・受注明細・特集ページ等）' },
              { item: '商品情報の深度', basic: '商品名・価格・カテゴリ', w2: '+ ブランド(5)・カテゴリ(5)・検索キーワード・クロスセル/アップセル関連商品' },
              { item: '在庫連動', basic: '基本在庫テーブル', w2: '+ W2バリエーション別在庫（サイズ・カラー単位の精密制御）' },
              { item: 'レコメンド精度', basic: '3層ハイブリッドAI', w2: '+ 人的クロスセル/アップセル知見をAIに統合' },
              { item: '配信タグ', basic: 'item_id + category_id', w2: '+ item_variation_id + brand_id' },
              { item: '表示制御', basic: '在庫0除外', w2: '+ 表示区分・有効フラグ・レコメンド利用フラグ・表示期間による精密フィルタ' },
              { item: 'モデル学習データ', basic: 'Event + OrderHistory', w2: '+ W2受注明細 + クロスセル/アップセルペアの暗黙スコア' },
            ].map((row, i) => (
              <div key={i} style={{
                display: 'grid',
                gridTemplateColumns: '2fr 2fr 3fr',
                gap: 0,
                padding: '10px 18px',
                borderTop: '1px solid rgba(255,255,255,0.05)',
                fontSize: 12,
                alignItems: 'center',
              }}>
                <span style={{ fontWeight: 700, color: 'rgba(255,255,255,0.75)' }}>{row.item}</span>
                <span style={{ color: 'rgba(255,255,255,0.45)', paddingRight: 12 }}>{row.basic}</span>
                <span style={{ color: '#a5b4fc', fontWeight: 500 }}>{row.w2}</span>
              </div>
            ))}
          </div>

          {/* W2連動の強み（カード4枚） */}
          <h3 style={{ ...s.subHeading, marginBottom: 14 }}>W2連動の強み</h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 12,
            marginBottom: 28,
          }}>
            {[
              {
                icon: '14',
                title: '14マスタ完全同期',
                color: '#6366f1',
                items: [
                  'W2の全データを高頻度連携でリアルタイムに活用',
                  'CSV一括/FTP自動連携に対応',
                  'ユーザー属性・CPMクラスタも活用',
                ],
              },
              {
                icon: 'H×A',
                title: '人×AI ハイブリッド推薦',
                color: '#10b981',
                items: [
                  'MD担当者が設定したクロスセル/アップセルをAIが学習',
                  '人的知見とAI予測の相乗効果',
                  '関連商品ペアに暗黙スコアを付与',
                ],
              },
              {
                icon: 'VAR',
                title: 'バリエーション別精密在庫',
                color: '#f59e0b',
                items: [
                  'サイズ・カラー単位の在庫連動',
                  '全バリエーション在庫0時のみ非表示',
                  '購入タグでリアルタイム在庫減算',
                ],
              },
              {
                icon: 'W2',
                title: 'W2商品ルール完全準拠',
                color: '#8b5cf6',
                items: [
                  '表示区分(display_kbn)に準拠',
                  '有効/無効フラグを厳密に反映',
                  '表示期間(FROM-TO)による自動制御',
                  'レコメンド利用フラグで精密な出し分け',
                ],
              },
            ].map((card, i) => (
              <div key={i} style={{
                padding: '18px 20px',
                background: 'rgba(255,255,255,0.04)',
                border: `1px solid ${card.color}30`,
                borderLeft: `3px solid ${card.color}`,
                borderRadius: 14,
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                  <div style={{
                    width: 38, height: 38, borderRadius: 10,
                    background: `${card.color}18`, color: card.color,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11, fontWeight: 800, flexShrink: 0, fontFamily: 'monospace',
                  }}>{card.icon}</div>
                  <h4 style={{ fontSize: 14, fontWeight: 700, color: 'rgba(255,255,255,0.85)', margin: 0 }}>{card.title}</h4>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {card.items.map((item, j) => (
                    <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 12, color: 'rgba(255,255,255,0.55)', lineHeight: 1.5 }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: card.color, flexShrink: 0, marginTop: 4 }} />
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* データフロー図 */}
          <h3 style={{ ...s.subHeading, marginBottom: 14 }}>データフロー</h3>
          <div style={{
            padding: '24px 28px',
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 16,
          }}>
            {/* フロー図 */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0 }}>
              {/* W2Commerce */}
              <div style={{
                padding: '10px 24px', borderRadius: 10,
                background: 'rgba(99,102,241,0.15)', border: '1px solid rgba(99,102,241,0.3)',
                fontSize: 13, fontWeight: 700, color: '#a5b4fc',
              }}>W2 Commerce</div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, padding: '6px 0' }}>
                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>[FTP / CSV]</span>
                <span style={{ fontSize: 16, color: 'rgba(255,255,255,0.3)' }}>↓</span>
              </div>
              {/* W2マスタ */}
              <div style={{
                padding: '10px 24px', borderRadius: 10,
                background: 'rgba(99,102,241,0.1)', border: '1px solid rgba(99,102,241,0.2)',
                fontSize: 13, fontWeight: 600, color: '#c7d2fe',
              }}>W2マスタ 14テーブル</div>
              <div style={{ fontSize: 16, color: 'rgba(255,255,255,0.3)', padding: '6px 0' }}>↓</div>
              {/* レコメンドエンジン */}
              <div style={{
                padding: '12px 28px', borderRadius: 10,
                background: 'rgba(139,92,246,0.15)', border: '1px solid rgba(139,92,246,0.3)',
                fontSize: 13, fontWeight: 700, color: '#c084fc', textAlign: 'center',
              }}>
                <div style={{ marginBottom: 8 }}>レコメンドエンジン</div>
                <div style={{ display: 'flex', gap: 16, fontSize: 11, color: 'rgba(255,255,255,0.5)' }}>
                  <span>協調フィルタ</span>
                  <span>ニューラル</span>
                  <span>コンテンツベース</span>
                </div>
              </div>
              <div style={{ fontSize: 16, color: 'rgba(255,255,255,0.3)', padding: '6px 0' }}>↓</div>
              {/* W2ルールフィルタ */}
              <div style={{
                padding: '10px 24px', borderRadius: 10,
                background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)',
                fontSize: 12, fontWeight: 600, color: '#fbbf24', textAlign: 'center',
              }}>
                W2ルール フィルタリング<br />
                <span style={{ fontSize: 11, fontWeight: 400, color: 'rgba(255,255,255,0.4)' }}>(表示区分 / 有効 / 在庫 / 期間)</span>
              </div>
              <div style={{ fontSize: 16, color: 'rgba(255,255,255,0.3)', padding: '6px 0' }}>↓</div>
              {/* ウィジェット表示 */}
              <div style={{
                padding: '10px 24px', borderRadius: 10,
                background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.25)',
                fontSize: 13, fontWeight: 700, color: '#34d399',
              }}>ウィジェット表示</div>
            </div>
          </div>
        </section>
      )}

      {/* Slide 12: GEO/LLMO分析 */}
      {activeSlide === 11 && (
        <section style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.sectionNum}>12</span>
            <div>
              <h2 style={s.sectionTitle}>GEO/LLMO ブランド可視化分析</h2>
              <p style={s.sectionSub}>AI検索時代に「AIがあなたのブランドをどう語るか」を可視化・最適化する</p>
            </div>
          </div>

          {/* 時代背景バナー */}
          <div style={{
            padding: '20px 28px', borderRadius: 14, marginBottom: 28,
            background: 'linear-gradient(135deg, rgba(99,102,241,0.15) 0%, rgba(236,72,153,0.1) 100%)',
            border: '1px solid rgba(99,102,241,0.2)',
          }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#e2e8f0', marginBottom: 8 }}>
              なぜ今、GEO/LLMO対策が必要なのか？
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.8 }}>
              ChatGPT・Gemini・Perplexityなどの<strong style={{ color: '#a5b4fc' }}>AI検索</strong>が急速に普及し、
              ユーザーの情報収集行動が「検索エンジン」から「AIへの質問」へと変化しています。
              従来のSEOだけでは、<strong style={{ color: '#f59e0b' }}>AIがブランドをどう評価し、ユーザーに推奨しているか</strong>が見えません。
              GEO（Generative Engine Optimization）/ LLMO（Large Language Model Optimization）は、
              この<strong style={{ color: '#ec4899' }}>AIの回答における自社ブランドの存在感</strong>を測定・最適化する新領域です。
            </div>
          </div>

          {/* 4つの分析機能カード */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 28 }}>
            {[
              {
                icon: '📊', color: '#6366f1', title: 'サイテーション分析',
                desc: 'ブランドがWeb上のどこで、どのように言及されているかを網羅的に調査。競合との言及量・カテゴリ分布を比較し、ブランド露出戦略を立案します。',
                metrics: '言及元50+サイト分析 / カテゴリ別比較 / 戦略レポート',
              },
              {
                icon: '🎯', color: '#ec4899', title: 'シェア・オブ・ボイス',
                desc: '「おすすめの○○は？」等のAIへの質問群で、自社が言及される割合を計測。AI検索における市場占有率（SOV）を定量化します。',
                metrics: '10-15プロンプト自動生成 / 競合5社比較 / シェア率算出',
              },
              {
                icon: '💬', color: '#10b981', title: 'センチメント分析',
                desc: 'AIが自社をポジティブに語るか、ネガティブに語るかを定量評価。「推奨」「列挙」「懸念」のいずれかを判別し、改善ポイントを特定します。',
                metrics: '感情スコア0-1.0 / 推奨レベル5段階 / 改善提案',
              },
              {
                icon: '🔄', color: '#f59e0b', title: 'クエリ・ファンアウト',
                desc: 'AI会話が深まる過程で、自社が「最後まで推奨され続けるか」を分析。比較検討→購入決定までの各段階での持続性を可視化します。',
                metrics: '会話4段階追跡 / 持続スコア / 脱落ポイント特定',
              },
            ].map((f, i) => (
              <div key={i} style={{
                padding: 22, borderRadius: 14,
                background: 'rgba(255,255,255,0.03)',
                border: `1px solid ${f.color}33`,
                transition: 'all 0.2s',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                  <span style={{
                    display: 'inline-flex', width: 36, height: 36, borderRadius: 10,
                    background: `${f.color}22`, alignItems: 'center', justifyContent: 'center', fontSize: 18,
                  }}>{f.icon}</span>
                  <h4 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: f.color }}>{f.title}</h4>
                </div>
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, margin: '0 0 10px' }}>{f.desc}</p>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 8 }}>
                  {f.metrics}
                </div>
              </div>
            ))}
          </div>

          {/* 共通機能バー */}
          <div style={{
            display: 'flex', gap: 12, marginBottom: 28,
            padding: '14px 20px', borderRadius: 10,
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)',
            flexWrap: 'wrap',
          }}>
            {[
              { icon: '💾', label: '入力値保存・共有', desc: '4分析間でブランド・競合情報を共有' },
              { icon: '📊', label: '分析履歴・比較', desc: '過去の結果と差分を即座に比較' },
              { icon: '🔍', label: 'サイト調査連動', desc: 'GSC認証でリアルデータ分析' },
            ].map((f, i) => (
              <div key={i} style={{ flex: 1, minWidth: 150, display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 16 }}>{f.icon}</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#e2e8f0' }}>{f.label}</div>
                  <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* 従来SEO vs GEO/LLMO 比較 */}
          <div style={{
            borderRadius: 14, overflow: 'hidden', marginBottom: 28,
            border: '1px solid rgba(255,255,255,0.08)',
          }}>
            <div style={{
              display: 'grid', gridTemplateColumns: '2fr 3fr 3fr',
              background: 'rgba(99,102,241,0.12)', padding: '12px 20px',
              fontSize: 12, fontWeight: 700, color: '#a5b4fc',
            }}>
              <div></div>
              <div style={{ textAlign: 'center' }}>従来のSEO</div>
              <div style={{ textAlign: 'center' }}>GEO/LLMO分析</div>
            </div>
            {[
              { label: '対象', seo: 'Google検索の順位', geo: 'AI（ChatGPT/Gemini等）の回答' },
              { label: '指標', seo: '検索順位・CTR・流入数', geo: 'シェア率・センチメント・持続性' },
              { label: '可視化', seo: 'キーワード別の順位推移', geo: 'AIがブランドを語る文脈・トーン' },
              { label: '競合比較', seo: '同じKWでの順位比較', geo: 'AIの推奨頻度・ポジション比較' },
              { label: '改善手法', seo: 'コンテンツ・被リンク最適化', geo: '権威性・信頼性・独自性の強化' },
            ].map((row, i) => (
              <div key={i} style={{
                display: 'grid', gridTemplateColumns: '2fr 3fr 3fr',
                padding: '10px 20px', fontSize: 12,
                background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
                borderTop: '1px solid rgba(255,255,255,0.05)',
              }}>
                <div style={{ fontWeight: 600, color: 'rgba(255,255,255,0.7)' }}>{row.label}</div>
                <div style={{ color: 'rgba(255,255,255,0.45)', textAlign: 'center' }}>{row.seo}</div>
                <div style={{ color: '#a5b4fc', textAlign: 'center', fontWeight: 500 }}>{row.geo}</div>
              </div>
            ))}
          </div>

          {/* 導入メリットまとめ */}
          <div style={{
            padding: '22px 28px', borderRadius: 14,
            background: 'linear-gradient(135deg, rgba(16,185,129,0.1) 0%, rgba(99,102,241,0.08) 100%)',
            border: '1px solid rgba(16,185,129,0.2)',
          }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#6ee7b7', marginBottom: 12 }}>
              GEO/LLMO分析で得られるもの
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              {[
                { num: '01', title: 'AI上のブランド認知度', desc: 'ChatGPTやGeminiで自社が何%の確率で推奨されているかを数値化' },
                { num: '02', title: '競合との相対評価', desc: '同カテゴリの競合と比較し、AIの回答における立ち位置を明確化' },
                { num: '03', title: '具体的な改善アクション', desc: 'AIの評価を向上させるための、コンテンツ戦略・権威性強化施策を提案' },
              ].map((m, i) => (
                <div key={i}>
                  <div style={{ fontSize: 20, fontWeight: 800, color: 'rgba(16,185,129,0.3)', marginBottom: 4 }}>{m.num}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#e2e8f0', marginBottom: 4 }}>{m.title}</div>
                  <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>{m.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer style={s.footer}>
        <p style={s.footerText}>W2 Smart Hub &mdash; Service Guide</p>
      </footer>
    </div>
  )
}

/* Styles */
const s = {
  page: {
    maxWidth: 960,
    margin: '0 auto',
    padding: '0 0 40px',
  },

  /* Hero */
  hero: {
    textAlign: 'center',
    padding: '48px 32px 36px',
    background: 'linear-gradient(160deg, rgba(99,102,241,0.12) 0%, rgba(139,92,246,0.08) 50%, rgba(15,23,42,0) 100%)',
    borderRadius: 24,
    border: '1px solid rgba(99,102,241,0.12)',
    marginBottom: 32,
  },
  heroBadge: {
    display: 'inline-block',
    padding: '4px 18px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    background: 'rgba(99,102,241,0.15)',
    color: '#a5b4fc',
    marginBottom: 16,
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    color: '#fff',
    margin: '0 0 6px',
    letterSpacing: '-0.02em',
  },
  heroAccent: {
    background: 'linear-gradient(135deg, #818cf8 0%, #c084fc 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  heroSub: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(255,255,255,0.4)',
    margin: '0 0 18px',
    letterSpacing: '0.06em',
  },
  heroDesc: {
    fontSize: 15,
    color: 'rgba(255,255,255,0.7)',
    lineHeight: 1.8,
    margin: '0 0 28px',
  },
  engineLabelWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginBottom: 18,
    justifyContent: 'center',
  },
  engineLabelLine: {
    flex: 1,
    maxWidth: 120,
    height: 1,
    background: 'linear-gradient(90deg, transparent, rgba(165,180,252,0.4), transparent)',
  },
  engineLabel: {
    fontSize: 16,
    fontWeight: 900,
    letterSpacing: '0.18em',
    background: 'linear-gradient(135deg, #a5b4fc 0%, #c084fc 50%, #818cf8 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textTransform: 'uppercase',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  heroEngine: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: 0,
    marginBottom: 12,
    flexWrap: 'wrap',
  },
  engineBlock: {
    background: 'linear-gradient(160deg, rgba(99,102,241,0.15) 0%, rgba(139,92,246,0.08) 100%)',
    border: '1px solid rgba(99,102,241,0.25)',
    borderRadius: 18,
    padding: '24px 28px 20px',
    minWidth: 180,
    textAlign: 'center',
    position: 'relative',
  },
  engineWeight: {
    fontSize: 44,
    fontWeight: 900,
    background: 'linear-gradient(135deg, #a5b4fc 0%, #c084fc 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    lineHeight: 1,
    marginBottom: 8,
  },
  enginePct: {
    fontSize: 20,
    fontWeight: 700,
  },
  engineName: {
    fontSize: 14,
    fontWeight: 700,
    color: 'rgba(255,255,255,0.85)',
    marginBottom: 4,
  },
  engineDetail: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.4)',
    lineHeight: 1.4,
  },
  engineX: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 10px',
  },
  engineXmark: {
    width: 36,
    height: 36,
    borderRadius: 18,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    fontWeight: 700,
    color: 'rgba(255,255,255,0.35)',
  },
  engineResult: {
    textAlign: 'center',
    fontSize: 15,
    fontWeight: 700,
    color: '#a5b4fc',
    marginBottom: 32,
    letterSpacing: '0.02em',
  },

  /* Agenda */
  agendaSection: {
    marginBottom: 32,
  },
  agendaSectionTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: 'rgba(255,255,255,0.85)',
    textAlign: 'center',
    margin: '0 0 20px',
    letterSpacing: '0.02em',
  },
  agendaGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 12,
  },
  agendaCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '18px 20px',
    borderRadius: 16,
    border: '1px solid rgba(226,232,240,0.2)',
    background: 'rgba(255,255,255,0.92)',
    cursor: 'pointer',
    transition: 'all 0.25s',
    textAlign: 'left',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  },
  agendaCardActive: {
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    border: '1px solid rgba(99,102,241,0.5)',
    boxShadow: '0 8px 30px rgba(99,102,241,0.3)',
    transform: 'scale(1.02)',
  },
  agendaNum: {
    width: 48,
    height: 48,
    borderRadius: 14,
    background: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
    color: '#4f46e5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    fontWeight: 900,
    flexShrink: 0,
    letterSpacing: '-0.02em',
  },
  agendaNumActive: {
    background: 'rgba(255,255,255,0.2)',
    color: '#fff',
  },
  agendaBody: {
    flex: 1,
    minWidth: 0,
  },
  agendaLabel: {
    fontSize: 15,
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: 3,
  },
  agendaLabelActive: {
    color: '#fff',
  },
  agendaMsg: {
    fontSize: 11,
    color: '#64748b',
    lineHeight: 1.4,
  },
  agendaMsgActive: {
    color: 'rgba(255,255,255,0.75)',
  },
  agendaHint: {
    textAlign: 'center',
    fontSize: 13,
    color: 'rgba(255,255,255,0.35)',
    margin: '0 0 18px',
    letterSpacing: '0.02em',
  },
  sectionDivider: {
    height: 1,
    background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.15) 30%, rgba(255,255,255,0.15) 70%, transparent 100%)',
    marginBottom: 32,
  },

  /* Section */
  section: { marginBottom: 32 },
  sectionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 18,
    marginBottom: 28,
  },
  sectionNum: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 44,
    height: 44,
    borderRadius: 14,
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    color: '#fff',
    fontSize: 16,
    fontWeight: 800,
    flexShrink: 0,
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: 'rgba(255,255,255,0.9)',
    margin: '0 0 4px',
  },
  sectionSub: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.45)',
    margin: 0,
  },
  subHeading: {
    fontSize: 16,
    fontWeight: 700,
    color: 'rgba(255,255,255,0.75)',
    margin: '0 0 12px',
    paddingLeft: 2,
  },
  subDesc: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.45)',
    margin: '0 0 16px',
    lineHeight: 1.6,
  },

  /* Slide 1 */
  painGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 14,
    marginBottom: 24,
  },
  painCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
    padding: '20px 22px',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16,
  },
  painDot: {
    width: 10, height: 10, borderRadius: '50%', flexShrink: 0, marginTop: 5,
  },
  painTitle: {
    fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.85)', margin: '0 0 6px',
  },
  painDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.5)', margin: 0, lineHeight: 1.6,
  },
  statBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '18px 24px',
    background: 'linear-gradient(135deg, rgba(245,158,11,0.1) 0%, rgba(239,68,68,0.06) 100%)',
    border: '1px solid rgba(245,158,11,0.2)',
    borderRadius: 16,
  },
  statIcon: {
    width: 36, height: 36, borderRadius: 10,
    background: 'rgba(245,158,11,0.15)', color: '#fbbf24',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 18, fontWeight: 800, flexShrink: 0,
  },
  statText: { fontSize: 14, color: 'rgba(255,255,255,0.7)', margin: 0, lineHeight: 1.7 },
  statHighlight: { fontSize: 22, fontWeight: 800, color: '#fbbf24', margin: '0 4px' },
  solutionBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: '20px 24px',
    background: 'linear-gradient(135deg, rgba(99,102,241,0.1) 0%, rgba(139,92,246,0.06) 100%)',
    border: '1px solid rgba(99,102,241,0.2)',
    borderRadius: 16,
  },
  solutionIcon: {
    width: 44, height: 44, borderRadius: 12,
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, flexShrink: 0,
  },
  solutionTitle: { fontSize: 15, fontWeight: 700, color: '#c7d2fe', margin: '0 0 6px' },
  solutionDesc: { fontSize: 13, color: 'rgba(255,255,255,0.6)', margin: 0, lineHeight: 1.7 },

  /* Slide 2 */
  logicGrid5: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: 10,
    marginBottom: 8,
  },
  logicCard: {
    padding: '20px 14px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 16,
    textAlign: 'center',
  },
  logicIcon: {
    width: 42, height: 42, borderRadius: 12,
    background: 'linear-gradient(135deg, rgba(99,102,241,0.2) 0%, rgba(139,92,246,0.15) 100%)',
    color: '#a5b4fc',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, marginBottom: 10,
  },
  logicLabel: { fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.85)', marginBottom: 6 },
  logicDesc: { fontSize: 11, color: 'rgba(255,255,255,0.5)', margin: '0 0 8px', lineHeight: 1.5 },
  logicScene: {
    display: 'inline-block', padding: '3px 10px', borderRadius: 8,
    fontSize: 10, fontWeight: 600, background: 'rgba(99,102,241,0.1)', color: '#818cf8',
  },

  /* Tracking events table */
  trackingTable: {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 14,
    overflow: 'hidden',
  },
  trackingHeader: {
    display: 'flex', gap: 8, padding: '10px 18px',
    background: 'rgba(255,255,255,0.04)',
    fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)',
    textTransform: 'uppercase', letterSpacing: '0.05em',
  },
  trackingRow: {
    display: 'flex', gap: 8, padding: '10px 18px',
    borderTop: '1px solid rgba(255,255,255,0.04)',
    fontSize: 12, alignItems: 'center',
  },
  tagBadge: {
    display: 'inline-block', padding: '2px 8px', borderRadius: 6,
    fontSize: 10, fontWeight: 600, background: 'rgba(99,102,241,0.1)', color: '#818cf8',
  },
  classifyBadge: {
    display: 'inline-block', padding: '2px 8px', borderRadius: 6,
    fontSize: 10, fontWeight: 600, background: 'rgba(16,185,129,0.1)', color: '#34d399',
    fontFamily: 'monospace',
  },

  /* Slide 3: Admin features */
  adminCatHeader: {
    display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12,
  },
  adminCatDot: { width: 10, height: 10, borderRadius: 5, flexShrink: 0 },
  adminCatTitle: { fontSize: 16, fontWeight: 700, color: 'rgba(255,255,255,0.8)', margin: 0 },
  adminGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10,
  },
  adminCard: {
    padding: '16px 18px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 12,
    borderLeft: '3px solid',
    position: 'relative',
  },
  adminCardBar: { position: 'absolute', left: 0, top: 0, bottom: 0, width: 3, borderRadius: '12px 0 0 12px' },
  adminCardTitle: { fontSize: 14, fontWeight: 700, color: 'rgba(255,255,255,0.85)', margin: '0 0 4px' },
  adminCardDesc: { fontSize: 12, color: 'rgba(255,255,255,0.5)', margin: 0, lineHeight: 1.6 },

  highlightBanner: {
    display: 'flex', alignItems: 'center', gap: 0,
    padding: '18px 24px',
    background: 'rgba(99,102,241,0.06)',
    border: '1px solid rgba(99,102,241,0.15)',
    borderRadius: 16,
  },
  highlightItem: {
    flex: 1, display: 'flex', alignItems: 'center', gap: 12,
  },
  highlightDivider: {
    width: 1, height: 40, background: 'rgba(255,255,255,0.08)', margin: '0 16px',
  },
  highlightIcon: {
    width: 36, height: 36, borderRadius: 10,
    background: 'rgba(99,102,241,0.12)', color: '#818cf8',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 800, flexShrink: 0, fontFamily: 'monospace',
  },
  highlightTitle: { fontSize: 13, fontWeight: 700, color: 'rgba(255,255,255,0.8)' },
  highlightDesc: { fontSize: 11, color: 'rgba(255,255,255,0.45)', marginTop: 2 },

  /* Slide 4: Analysis */
  analysisCard: {
    padding: '20px 22px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16,
    marginBottom: 14,
  },
  analysisHeader: {
    display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14,
  },
  analysisIcon: {
    width: 40, height: 40, borderRadius: 12,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, flexShrink: 0,
  },
  analysisTitle: { fontSize: 16, fontWeight: 700, color: 'rgba(255,255,255,0.9)', margin: 0 },
  analysisList: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 20px',
  },
  analysisItem: {
    display: 'flex', alignItems: 'flex-start', gap: 8,
  },
  analysisDot: { width: 6, height: 6, borderRadius: 3, flexShrink: 0, marginTop: 5 },
  analysisText: { fontSize: 13, color: 'rgba(255,255,255,0.6)', lineHeight: 1.5 },
  aiBanner: {
    display: 'flex', alignItems: 'center', gap: 16,
    padding: '20px 24px',
    background: 'linear-gradient(135deg, rgba(16,185,129,0.08) 0%, rgba(99,102,241,0.06) 100%)',
    border: '1px solid rgba(16,185,129,0.2)',
    borderRadius: 16, marginTop: 8,
  },
  aiIcon: {
    width: 44, height: 44, borderRadius: 12,
    background: 'linear-gradient(135deg, #10b981, #34d399)', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, flexShrink: 0,
  },
  aiBannerTitle: { fontSize: 15, fontWeight: 700, color: '#34d399', margin: '0 0 6px' },
  aiBannerDesc: { fontSize: 13, color: 'rgba(255,255,255,0.6)', margin: 0, lineHeight: 1.7 },

  /* Slide 5: KPIs */
  kpiGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 28,
  },
  kpiCard: {
    padding: '22px 16px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 16, textAlign: 'center',
  },
  kpiIcon: {
    width: 32, height: 32, borderRadius: 10,
    background: 'linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(52,211,153,0.1) 100%)',
    color: '#34d399',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 16, fontWeight: 800, marginBottom: 8,
  },
  kpiValue: { fontSize: 20, fontWeight: 800, color: '#818cf8', marginBottom: 2, letterSpacing: '0.05em' },
  kpiLabel: { fontSize: 13, fontWeight: 700, color: 'rgba(255,255,255,0.85)', marginBottom: 6 },
  kpiDesc: { fontSize: 11, color: 'rgba(255,255,255,0.45)', margin: 0, lineHeight: 1.5 },

  dashPreview: {
    padding: '22px 26px',
    background: 'rgba(99,102,241,0.06)',
    border: '1px solid rgba(99,102,241,0.15)',
    borderRadius: 16, marginBottom: 8,
  },
  dashTitle: { fontSize: 14, fontWeight: 700, color: 'rgba(255,255,255,0.8)', margin: '0 0 14px' },
  dashGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  dashItem: {
    display: 'flex', alignItems: 'center', gap: 10,
    fontSize: 13, color: 'rgba(255,255,255,0.6)',
  },
  dashDot1: { width: 8, height: 8, borderRadius: '50%', background: '#6366f1', flexShrink: 0 },
  dashDot2: { width: 8, height: 8, borderRadius: '50%', background: '#10b981', flexShrink: 0 },
  dashDot3: { width: 8, height: 8, borderRadius: '50%', background: '#f59e0b', flexShrink: 0 },
  dashDot4: { width: 8, height: 8, borderRadius: '50%', background: '#ec4899', flexShrink: 0 },

  /* Before/After */
  compareGrid: {
    display: 'flex', alignItems: 'stretch', gap: 0,
  },
  compareCard: {
    flex: 1, padding: '20px 22px',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16,
  },
  compareBadgeBefore: {
    display: 'inline-block', padding: '3px 14px', borderRadius: 8,
    fontSize: 11, fontWeight: 800, background: 'rgba(239,68,68,0.12)', color: '#f87171',
    marginBottom: 14, letterSpacing: '0.06em',
  },
  compareBadgeAfter: {
    display: 'inline-block', padding: '3px 14px', borderRadius: 8,
    fontSize: 11, fontWeight: 800, background: 'rgba(16,185,129,0.12)', color: '#34d399',
    marginBottom: 14, letterSpacing: '0.06em',
  },
  compareList: { display: 'flex', flexDirection: 'column', gap: 8 },
  compareItem: {
    fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.5,
    paddingLeft: 14, position: 'relative',
  },
  compareItemGood: {
    fontSize: 13, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5,
    paddingLeft: 14, position: 'relative',
  },
  compareArrow: {
    display: 'flex', alignItems: 'center', fontSize: 22, color: 'rgba(255,255,255,0.15)',
    padding: '0 12px', flexShrink: 0,
  },

  /* Slide 6: Steps timeline */
  stepsTimeline: {
    display: 'flex', flexDirection: 'column', gap: 0, marginBottom: 28,
  },
  timelineItem: {
    display: 'flex', gap: 18,
  },
  timelineLine: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', width: 20, flexShrink: 0,
  },
  timelineDot: {
    width: 14, height: 14, borderRadius: 7, flexShrink: 0,
  },
  timelineConnector: {
    width: 2, flex: 1, background: 'rgba(255,255,255,0.1)', minHeight: 20,
  },
  timelineContent: {
    flex: 1, paddingBottom: 24,
  },
  timelineHeader: {
    display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6,
  },
  timelineNum: {
    padding: '3px 12px', borderRadius: 6, fontSize: 10, fontWeight: 800,
    color: '#fff', letterSpacing: '0.06em',
  },
  timelineDuration: {
    fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.4)',
  },
  timelineTitle: {
    fontSize: 16, fontWeight: 700, color: 'rgba(255,255,255,0.85)', margin: '0 0 4px',
  },
  timelineDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.5)', margin: 0, lineHeight: 1.6,
  },

  /* Guide preview */
  guidePreview: {
    padding: '22px 26px',
    background: 'rgba(99,102,241,0.06)',
    border: '1px solid rgba(99,102,241,0.15)',
    borderRadius: 16, marginBottom: 20,
  },
  guideTitle: { fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.8)', margin: '0 0 8px' },
  guideDesc: { fontSize: 13, color: 'rgba(255,255,255,0.55)', margin: '0 0 14px', lineHeight: 1.6 },
  guideSteps: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  guideStep: {
    display: 'flex', alignItems: 'center', gap: 6,
    padding: '5px 14px', borderRadius: 8,
    background: 'rgba(99,102,241,0.1)', color: '#a5b4fc',
    fontSize: 12, fontWeight: 600,
  },
  guideStepDot: { width: 6, height: 6, borderRadius: 3, background: '#818cf8' },

  /* Support */
  supportBanner: {
    padding: '22px 26px',
    background: 'rgba(16,185,129,0.06)',
    border: '1px solid rgba(16,185,129,0.15)',
    borderRadius: 16,
  },
  supportTitle: { fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.8)', margin: '0 0 14px' },
  supportGrid: { display: 'flex', gap: 16 },
  supportItem: { flex: 1, display: 'flex', alignItems: 'flex-start', gap: 10 },
  supportIcon: {
    width: 32, height: 32, borderRadius: 8,
    background: 'rgba(16,185,129,0.12)', color: '#34d399',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 14, fontWeight: 800, flexShrink: 0,
  },
  supportLabel: { fontSize: 13, fontWeight: 700, color: 'rgba(255,255,255,0.8)' },
  supportDesc: { fontSize: 12, color: 'rgba(255,255,255,0.45)', marginTop: 2 },

  /* Slide 7-8: EC Features */
  ecFeatureList: {
    display: 'flex', flexDirection: 'column', gap: 16,
  },
  ecFeatureCard: {
    display: 'flex', gap: 20,
    padding: '24px 26px',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 18,
    transition: 'all 0.2s',
  },
  ecFeatureLeft: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
    minWidth: 80, flexShrink: 0,
  },
  ecFeatureIcon: {
    width: 52, height: 52, borderRadius: 14,
    background: 'linear-gradient(135deg, rgba(99,102,241,0.2) 0%, rgba(139,92,246,0.15) 100%)',
    color: '#a5b4fc',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 16, fontWeight: 800,
  },
  ecFeatureMeta: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
  },
  ecFeatureLogic: {
    padding: '2px 10px', borderRadius: 6,
    fontSize: 10, fontWeight: 700,
    background: 'rgba(99,102,241,0.12)', color: '#818cf8',
    whiteSpace: 'nowrap',
  },
  ecFeatureScene: {
    fontSize: 10, color: 'rgba(255,255,255,0.35)',
    textAlign: 'center', lineHeight: 1.3,
  },
  ecFeatureRight: { flex: 1 },
  ecFeatureTitle: {
    fontSize: 17, fontWeight: 700, color: 'rgba(255,255,255,0.9)',
    margin: '0 0 8px',
  },
  ecFeatureDesc: {
    fontSize: 14, color: 'rgba(255,255,255,0.55)',
    margin: 0, lineHeight: 1.8,
  },

  /* Mail flow */
  mailFlowBox: {
    padding: '24px 26px', marginTop: 24,
    background: 'rgba(99,102,241,0.06)',
    border: '1px solid rgba(99,102,241,0.15)',
    borderRadius: 16,
  },
  mailFlowTitle: {
    fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.8)',
    margin: '0 0 18px',
  },
  mailFlowSteps: {
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
  },
  mailFlowStep: {
    flex: 1, textAlign: 'center', maxWidth: 180,
  },
  mailFlowNum: {
    width: 28, height: 28, borderRadius: 14,
    background: 'rgba(99,102,241,0.2)', color: '#a5b4fc',
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 13, fontWeight: 800, marginBottom: 8,
  },
  mailFlowLabel: {
    fontSize: 13, fontWeight: 700, color: 'rgba(255,255,255,0.8)', marginBottom: 4,
  },
  mailFlowDesc: {
    fontSize: 11, color: 'rgba(255,255,255,0.45)', lineHeight: 1.5,
  },
  mailFlowArrow: {
    fontSize: 18, color: 'rgba(255,255,255,0.15)', padding: '10px 6px 0', flexShrink: 0,
  },

  /* Slide 9: Design */
  designGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14,
  },
  designCard: {
    display: 'flex', alignItems: 'flex-start', gap: 16,
    padding: '22px 24px',
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 16,
  },
  designCardIcon: {
    width: 46, height: 46, borderRadius: 12,
    background: 'linear-gradient(135deg, rgba(99,102,241,0.18) 0%, rgba(139,92,246,0.12) 100%)',
    color: '#a5b4fc',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 13, fontWeight: 800, flexShrink: 0, fontFamily: 'monospace',
  },
  designCardTitle: {
    fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.85)',
    margin: '0 0 6px',
  },
  designCardDesc: {
    fontSize: 13, color: 'rgba(255,255,255,0.5)',
    margin: 0, lineHeight: 1.7,
  },

  /* Slide 10: Scalability */
  specGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 28,
  },
  specCard: {
    padding: '20px 16px',
    background: 'linear-gradient(160deg, rgba(99,102,241,0.1) 0%, rgba(16,185,129,0.06) 100%)',
    border: '1px solid rgba(99,102,241,0.18)',
    borderRadius: 16, textAlign: 'center',
  },
  specValue: {
    fontSize: 24, fontWeight: 900, color: '#818cf8', marginBottom: 4, letterSpacing: '-0.02em',
  },
  specLabel: {
    fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.8)', marginBottom: 4,
  },
  specDesc: {
    fontSize: 11, color: 'rgba(255,255,255,0.4)', lineHeight: 1.4,
  },
  archBanner: {
    padding: '24px 26px', marginTop: 8,
    background: 'linear-gradient(135deg, rgba(16,185,129,0.06) 0%, rgba(99,102,241,0.06) 100%)',
    border: '1px solid rgba(16,185,129,0.18)',
    borderRadius: 16,
  },
  archTitle: {
    fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.8)', margin: '0 0 18px',
  },
  archFlow: {
    display: 'flex', flexDirection: 'column', gap: 0,
  },
  archStep: {
    display: 'flex', alignItems: 'center', gap: 14, padding: '10px 16px',
    background: 'rgba(255,255,255,0.03)', borderRadius: 10,
  },
  archDot: {
    width: 10, height: 10, borderRadius: 5, flexShrink: 0,
  },
  archStepLabel: {
    fontSize: 14, fontWeight: 700, color: 'rgba(255,255,255,0.85)',
  },
  archStepDesc: {
    fontSize: 12, color: 'rgba(255,255,255,0.45)', marginTop: 2,
  },
  archArrow: {
    textAlign: 'center', fontSize: 16, color: 'rgba(255,255,255,0.2)', padding: '2px 0',
  },
  archResult: {
    marginTop: 16, padding: '14px 20px',
    background: 'linear-gradient(135deg, rgba(16,185,129,0.12) 0%, rgba(52,211,153,0.06) 100%)',
    border: '1px solid rgba(16,185,129,0.25)',
    borderRadius: 12, textAlign: 'center',
    fontSize: 14, fontWeight: 700, color: '#34d399', letterSpacing: '0.02em',
  },

  /* Footer */
  footer: {
    textAlign: 'center',
    padding: '32px 0 0',
    borderTop: '1px solid rgba(255,255,255,0.06)',
    marginTop: 24,
  },
  footerText: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.25)',
    letterSpacing: '0.08em',
  },
}
